import { Button, Col, Form, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useAuth } from "../auth/useAuth"
import NotesPanel from "../notes/NotesPanel"
import { Save } from "lucide-react"

export default function ClientForm({
	state,
	handleInputChange,
	submit,
	isEditing,
	loadingdata,
}: {
	state: any
	handleInputChange: (e: any) => void
	submit: (e: any) => void
	isEditing: boolean
	loadingdata: boolean
}) {
	const { t } = useTranslation()
	const { clientauth } = useAuth()

	return (
		<Form onSubmit={submit} className="px-4 formulario">
			{loadingdata ? (
				<div className="text-center my-4">
					<span className="spinner-border spinner-border-lg align-middle" />
				</div>
			) : (
				<>
					<Row className="my-2">
						<NotesPanel
							value={state?.arrayNotes ?? []}
							currentUserId={clientauth?.id}
							onChange={(notes) =>
								handleInputChange({
									target: {
										name: "arrayNotes",
										value: notes,
									},
								})
							}
						/>
					</Row>
					<Row className="my-2">
						<Col xs={12} className="d-flex justify-content-end py-2">
							<Button
								variant="primary"
								type="submit"
								className="my-2 px-5"
								disabled={isEditing}
							>
								{isEditing ?
									<span className="spinner-border spinner-border-sm align-middle" />
								:
									<>
									 {t("global.save")} <Save size={16} />
									</>
								}
							</Button>
						</Col>
					</Row>
				</>
			)}
		</Form>
	)
}
